const VARIANT = process.env.REACT_APP_VARIANT || "svgtrace";

export const isSvgTrace = VARIANT === "svgtrace";
export const isEmbroideryTrace = VARIANT === "embroiderytrace";

export const appName = isSvgTrace ? "SvgTrace" : "EmbroideryTrace";
export const appTagline = isSvgTrace
  ? "Convert images to scalable vectors"
  : "Convert images to embroidery files";

export const features = {
  svgEditor: isSvgTrace,
  stitchEditor: !isSvgTrace,
  // Both brands have a community gallery; each reads its own collection and
  // Algolia index (see config/firebaseVariant.js), so they stay separate.
  community: true,
  explore: true,
};

// The tutorial walks through specific layers of this image, so each variant
// needs the artwork its own walkthrough was written against.
export const tutorialSampleFileName = isSvgTrace
  ? "tutorial_sample.png"
  : "embroidery_sample.png";
export const tutorialSampleImage = `/assets/${tutorialSampleFileName}`;

export default { isSvgTrace, isEmbroideryTrace, appName, appTagline, features };
